import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareS = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler21') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler21', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Gwd item 5m+!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Gwd item 5m+!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareS}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareS
  
